import {Component, EventEmitter, Input, Output} from "@angular/core";
import {OrderingContextIntention} from "../ordering-context";
import {ButtonProminence} from "../../buttons/button/button";
import {OrderingContextModel} from "../ordering-context.model";
import {OrderType} from "../../order/order";

@Component({
    selector: "woa-order-type-selection-panel",
    templateUrl: "./order-type-selection-panel.component.html"
})
export class OrderTypeSelectionPanelComponent {
    OrderType = OrderType;
    ButtonProminence = ButtonProminence;

    @Input() intention: OrderingContextIntention;
    @Input() canOrderAtTable: boolean;
    @Input() canOrderAhead: boolean;
    @Input() canOrderDelivery: boolean;
    @Output() onOrderTypeSelected: EventEmitter<OrderType> = new EventEmitter<OrderType>();

    orderType: OrderType;

    constructor(public orderingContextModel: OrderingContextModel) {
    }

    get intro(): string {
        return !this.intention ||
        this.intention === OrderingContextIntention.ORDER ||
        this.intention === OrderingContextIntention.SELECT_ORDER_TYPE ||
        this.intention === OrderingContextIntention.CHANGE_FULFILMENT_DETAILS ? undefined
            : this.orderingContextModel.singleStoreLocation ? "woa.message.order-type-selection.intro.viewSingleStore"
                : this.intention === OrderingContextIntention.VIEW_STORES ? "woa.message.order-type-selection.intro.viewStores"
                    : "woa.message.order-type-selection.intro.viewStore";
    }

    get orderAheadLabel(): string {
        return this.intention === OrderingContextIntention.VIEW_STORES ? "woa.button.order-type-selection.stores.orderAhead"
            : this.intention === OrderingContextIntention.VIEW_CURRENT_STORE ? "woa.button.order-type-selection.store.orderAhead"
                : "woa.button.order-type-selection.order.orderAhead";
    }

    get deliveryLabel(): string {
        return this.intention === OrderingContextIntention.VIEW_STORES ? "woa.button.order-type-selection.stores.orderDelivery"
            : this.intention === OrderingContextIntention.VIEW_CURRENT_STORE ? "woa.button.order-type-selection.store.orderDelivery"
                : "woa.button.order-type-selection.order.orderDelivery";
    }

    get orderAtTableLabel(): string {
        return this.intention === OrderingContextIntention.VIEW_STORES ? "woa.button.order-type-selection.stores.orderAtTable"
            : this.intention === OrderingContextIntention.VIEW_CURRENT_STORE ? "woa.button.order-type-selection.store.orderAtTable"
                : "woa.button.order-type-selection.order.orderAtTable";
    }
}



// WEBPACK FOOTER //
// ./src/app/ordering-context/order-type-selection-panel/order-type-selection-panel.component.ts